import React from 'react';
import { Area, Text, Link, Box, useTheme } from '@ublend-npm/aulaui-core';

const LearnMoreLink = () => (
  <Link
    href="https://aula.zendesk.com/hc/en-us/articles/15852659347218"
    fontFamily="Roboto, sans-serif"
  >
    Find out more
  </Link>
);

const StarSpaceOnboarding = () => {
  const { palette } = useTheme();
  return (
    <Box display="flex" justifyContent="center" padding="1rem 0 1.5rem 0">
      <Area
        display="flex"
        alignItems="center"
        flexDirection="column"
        sx={{ borderRadius: '0.5rem' }}
        width="100%"
      >
        <Text kind="p2" pb="0.5rem" fontWeight="600" fontSize="1rem">
          No starred spaces
        </Text>
        <Text
          textAlign="center"
          color={
            palette?.mode === 'dark'
              ? 'rgba(255, 255, 255, 0.7)'
              : 'rgba(0, 0, 0, 0.6)'
          }
        >
          Add your most important spaces to the starred tab for quick access by
          tapping the star icon next to a space name
        </Text>
        <LearnMoreLink />
      </Area>
    </Box>
  );
};

export default StarSpaceOnboarding;
